import { RadioField } from "common";
import { findIndex, get } from "lodash";
import React from "react";
import shallow from "zustand/shallow";
import { getMarketingConsentFields } from "@/models/Form/Form";
import { isPrimaryGuest } from "@/models/Guest";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const MarketingConsentField = React.memo(() => {
    const [item, activeItemIndex] = useCreatePurchaseStore(
        (state) => [state.getActiveItem(), state.activeItemIndex],
        shallow,
    );
    const { form } = item;
    const setPurchase = useCreatePurchaseStore((state) => state.actions.setPurchase);

    if (!form || !item.guests) {
        return null;
    }

    const { guests } = item;
    const isPerReservation = form.organizerOnly;
    const primaryGuest = guests.find((guest) => isPrimaryGuest(guest, undefined, item));
    const marketingConsentFields = form ? getMarketingConsentFields(form) : [];
    if (marketingConsentFields?.length === 0) {
        return null;
    }

    if (!isPerReservation && !primaryGuest?.formResponse) {
        // If it is per guest, we need a primary guest form response object
        return null;
    }

    const handleChange = (value: string, fieldIndex: number) => {
        setPurchase((draft) => {
            const draftItem = draft.items[activeItemIndex];
            if (isPerReservation) {
                if (draftItem.formResponse?.fields[fieldIndex]?.value) {
                    draftItem.formResponse.fields[fieldIndex].value = value;
                }
            } else {
                const guest = draftItem.guests?.find((guest) => guest.id === primaryGuest?.id);
                if (guest?.formResponse?.fields[fieldIndex]) {
                    guest.formResponse.fields[fieldIndex].value = value;
                }
            }
        });
    };

    return (
        <div className="space-y-2 pt-2 pb-2">
            {marketingConsentFields.map((field) => {
                const formResponse = isPerReservation ? item.formResponse : primaryGuest?.formResponse;
                const fields = formResponse?.fields ?? [];
                const guestIndex = guests.findIndex((guest) => guest.id === primaryGuest?.id) ?? 0;
                const fieldIndex = findIndex(fields, { type: field.type, label: field.label }) ?? 0;
                const name = isPerReservation
                    ? `formResponse.fields.${fieldIndex}.value`
                    : `guests.${guestIndex}.formResponse.fields.${fieldIndex}.value`;

                return (
                    <RadioField
                        key={field.id}
                        field={field}
                        name={name}
                        initialValue={get(item, name)} // Specify initial value for 'Resume Booking' functionality
                        classNames={{ description: "text-gray-darker" }}
                        onChange={(value) => handleChange(value, fieldIndex)}
                    />
                );
            })}
        </div>
    );
});
